import React, { useEffect, useRef, useState } from 'react'

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SelectStatus from '../components/select/SelectStatus';
import {  loadPage, savePage } from '../utils/Network';
import SelectIsFeatured from '../components/SelectIsFeatured';
import SelectLanguage from '../components/SelectLanguage';
import Gallery from './Gallery';
export default function PageContent({ id }) {

    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    
    const [status, setStatus] = useState(null);
    const [error, setError] = useState(false);
    const [category_id, setCategoryId] = useState(null);
    const [file, setFile] = useState(null);
    const [title, setTitle] = useState(null);
    const [url, setUrl] = useState(null);
    const [talent_id, setTalentId] = useState(null);
    const [description, setDescription] = useState(null);
    const [short_description, setShortDescription] = useState(null);
    const [keywords, setKeywords] = useState(null);
    const [image, setImage] = useState(null);
    const [is_featured, setIsFeatured] = useState(false);
    const [language_id, setLanguageId] = useState(false);
    const [gallery_modal_is_open, setGalleryModalIsOpen] = useState(false);
    const [gallery_item, setGalleryItem] = useState(false);
    
    
    const inputFileRef = useRef(null)

    useEffect(() => {
        if (id) {
            loadPage(id).then(page => {
                setStatus(page.status)
                setTitle(page.title)
                setUrl(page.url)
                setDescription(page.description)
                setShortDescription(page.short_description)
                setKeywords(page.keywords)
                setGalleryItem(page.gallery_image)
                setImage(page.gallery_image ? page.gallery_image.image : null)
                setIsFeatured(page.is_featured)
                setLanguageId(page.language)
            })

            
            
        }
    }, []);


    const onChange = (e) => {
        //alert(e.target.name)
        switch (e.target.name) {
            case 'title':
                setTitle(e.target.value)
                break;
            case 'url':
                    setUrl(e.target.value)
                    break;
            case 'short_description':
                setShortDescription(e.target.value)
                break;
            case 'keywords':
                setKeywords(e.target.value)
                break;
            default:

                break;
        }
    }
    const handleDescriptionChange = (data) => {
       setDescription(data)

    }


    const openGallery = () => {
        setGalleryModalIsOpen(true)
    }
    const closeGallery = () => {
        setGalleryModalIsOpen(false)
    }

    
    const handleValue = (value, name) => {
        switch (name) {
            case "status":
                setStatus(value)
                break;
            case "is_featured":
                setIsFeatured(value)
                break;
            case "language":
                setLanguageId(value)
                break;
                
            default:
                break;
        }
    }

    const handleFileChange = (e) => {
        var file = e.target.files[0]
        if (e.target.files)
            setFile(file)

    }

    const SaveChanges = () => {

        setError(null)
        
        if (!title) {
            setError("Please enter Title")
            return;
        }

        if (!description) {
            setError("Please enter Description")
            return;
        }

        if (!language_id) {
            setError("Please Select Language")
            return;
        }


        setLoading(true)
        savePage(id, title , url, short_description, description, keywords, is_featured, status, language_id, gallery_item ? gallery_item.id : null).then(page => {
            if (page.id){
                setDone("Changes saved successfully");
            }
            setLoading(false)
        })
    }

    const fileChange = () => {
        inputFileRef.current.click();
    }

    const setSelectedImageGallery = (gallery_item) => {
        setGalleryItem(gallery_item)
    }
    


    return (
        <>
           
            <Gallery setSelectedGalleryItem={setSelectedImageGallery} isOpen={gallery_modal_is_open} key={gallery_modal_is_open} closeGallery={() => { closeGallery()}} />

            <div className="content-wrapper">
                <section className="content-header">
                    <h3 className="box-title mb-10"></h3>
                    <ol className="breadcrumb">
                        <li><a href="/cms"><i className="fa fa-dashboard"></i> Home</a></li>
                        <li className="active">Page</li>
                    </ol>
                </section>
                <section className="content">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="box ">
                                <div className="box-header">
                                    Page Details
                                </div>
                                <div className="box-body padding-10 bg-ddd">
                                    <div className="form-group">
                                        <input type="text" value={title} name="title" onChange={onChange} className="form-control page-title" placeholder="Title" />
                                    </div>
                                    <div className="form-group">
                                        <input type="text" value={url} name="url" onChange={onChange} className="form-control page-title" placeholder="Url" />
                                    </div>
                                    <div className="form-group">
                                        <textarea type="text" name="short_description" onChange={onChange} className="form-control" placeholder="Short Description" value={short_description}  />
                                    </div>
                                    <div className="form-group">
                                        <CKEditor
                                            editor={ClassicEditor}
                                            data={description}
                                            onReady={editor => {
                                                // You can store the "editor" and use when it is needed.
                                            }}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                handleDescriptionChange(data)
                                            }}
                                        />
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="box bg-ddd">
                                <div className="box-header">
                                    Information
                                </div>
                                <div className="box-body padding-10">
                                    <div className="form-group">
                                        <input type="text" value={keywords} name="keywords" onChange={onChange} className="form-control max-250" placeholder="Keywords" />
                                    </div>
                                    <div className="form-group">
                                        <SelectLanguage width={250} callback={handleValue} value={language_id} border={"1"} />
                                    </div>
                                    <div className="form-group mb-3">
                                        <SelectStatus width={250} callback={handleValue} value={status} />
                                    </div>
                                    <div className="form-group mb-3">
                                        <SelectIsFeatured width={250} callback={handleValue} value={is_featured} />
                                    </div>
                                    <div className="form-group hide">
                                        <img className="img upload-img mb-5" onClick={fileChange} src={image ? image : "images/default.png"} />
                                        <input type="file" ref={inputFileRef} name="file" onChange={handleFileChange} className="form-control max-250 hide" />
                                    </div>
                                    <div className="form-group ">
                                        <img className="img upload-img mb-5" onClick={openGallery} src={gallery_item ? gallery_item.image : "images/default.png"} />
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <button className="btn btn-primary pull-right" onClick={SaveChanges}>Save Changes</button>
                                    <a href={`pages`} className="btn btn-default pull-left">Cancel</a>
                                </div>
                                {error &&
                                    <div className="alert alert-danger mt-5">
                                        {error}
                                    </div>
                                }
                                {loading &&
                                    <div className="alert alert-info  mt-5">
                                        Please Wait...
                                    </div>
                                }
                                {done &&
                                    <div className="alert alert-success  mt-5">
                                        {done}
                                    </div>
                                }
                            </div>

                        </div>
                    </div>
                </section>

                
            </div>
        </>



    )
}
